// extracted by mini-css-extract-plugin
module.exports = {"slider":"SpringSlider_slider__133N2","slides":"SpringSlider_slides__2R5LA"};